(function IIFE() {
    'use strict';

    /////////////////////////////

    function UserContentFactory($resource, Config) {
        'ngInject';

        return $resource(Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/usercontent/:methodKey', {}, {
            save: {
                isArray: false,
                method: 'POST',
                params: {
                    methodKey: 'save',
                },
            },
        });
    }

    /////////////////////////////

    angular.module('Factories').factory('UserContentFactory', UserContentFactory);
})();
